<template>
    <div class="modal-auth-select">
        <transition name="fade">
            <div class="modal-auth-select__loader"
                v-if="isLoading"
                >
                <div class="modal-auth-select__loader-container">
                    <ui-loader />
                </div>
            </div>
        </transition>
        <div class="modal-auth-select__title">
            Подтвердите номер телефона
        </div>
        <div class="modal-auth-select__text">
            Пожалуйста, подтвердите ваш номер телефона {{ formattedNumber }} для оформления заказа
        </div>
        <div class="modal-auth-select__form">
            <div class="modal-auth-select__form-error"
                v-if="error"
                v-text="error"
            />
            <div class="modal-auth-select__form-button">
                <ui-button
                    v-on:click="submitHandler(true)"
                    is-uppercase
                >
                    <icon name="telegram" width="38" height="38"/>
                    Войти через telegram
                </ui-button>
            </div>
            <div class="modal-auth-select__form-button">
                <ui-button
                    v-on:click="submitHandler(false)"
                    v-text="'Получить код по СМС'"
                    is-uppercase
                    is-bordered
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import utils from '~/utils';

export default {
    name: 'modal-auth-select',
    props: {
        phone: {
            type: String,
            default: null,
        },
        onSuccess: {
            type: Function,
            default: null,
        },
    },
    computed: {
        ...mapState('user', [
            'authResult',
            'authIsLoading',
            'authError',
        ]),
        isLoading() {
            return this.authIsLoading;
        },
        error() {
            return utils.network.parseError(this.authError, true);
        },
        formattedNumber() {
            return utils.formats.formatPhone(this.phone);
        },
    },
    methods: {
        submitHandler(telegram = false) {
            if (telegram) {
                this.showTelegramModal();
            } else {
                this.showSmsModal();
            }
        },
        showSmsModal() {
            this.$store.commit('modals/push', {
                name: 'sms-verification',
                props: {
                    phone: this.phone,
                    callback: this.onSuccess,
                },
            });
        },
        showTelegramModal() {
            this.$store.commit('modals/push', {
                name: 'auth-telegram',
                props: {
                    phone: this.phone,
                    onSuccess: () => {
                        if (this.onSuccess) {
                            this.onSuccess(1234);
                        }
                        this.close();
                    },
                    onShowSmsModal: () => {
                        this.showSmsModal();
                    },
                },
            });
        },
        close() {
            this.$store.commit('modals/pop');
        },
    },
    watch: {
        authIsLoading(newVal) {
            if (!newVal && this.authResult) {
                if (this.onSuccess) {
                    this.onSuccess();
                }
                this.close();
            }
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.modal-auth-select {
    .mixin-modal();

    position: relative;

    max-width: 340px;
    padding: 40px;

    box-shadow: 0 0 60px 0 @color-accent-cold;
    &__loader {
        .transition-fade();

        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;

        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        background: @color-gray-lightest;
        &-container {
            width: 50px;
        }
    }
    &__title {
        margin-bottom: 18px;

        text-transform: uppercase;
    }
    &__text {
        .typography-body-md();
        margin-bottom: 44px;
    }
    &__form {
        width: 100%;
        max-width: 260px;
        &-checkbox {
            margin-top: 12px;
        }
        &-error {
            margin-bottom: 36px;

            color: @color-accent-warm;
        }
        &-button {
            height: 48px;
            margin-top: 20px;
            &:last-child {
                margin-top: 8px;
            }
        }
    }
    &__disclaimer {
        margin-top: 16px;
        &-trigger {
            .mixin-link-decoration();

            cursor: pointer;
        }
    }
    @media @media-md-down {
        &__title {
            margin-bottom: 9px;
        }
    }
}
</style>
